module.exports = __webpack_public_path__ + "img/bg-3.a9fd5bee.webp";